export const themeColors = [
    '#0558D7', // グラデーションの左側、メインで使われる
    '#12E3DD', // グラデーションの右上、メインの次に使われる
    '#85DEEC', // グラデーションの右下、3番目に使われる
    '#A7A7A7' // グレー
];
export const basicColor = `linear-gradient(to right, ${themeColors[0]}, transparent), linear-gradient(to bottom, ${themeColors[1]}, ${themeColors[2]})`;